import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-590bc4d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, null, -1))
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = {
  class: "table align-middle fs-6 gy-5",
  id: "kt_ecommerce_add_product_reviews"
}
const _hoisted_7 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_11 = { class: "comment" }

import { ref, onMounted } from "vue";
import CreateBatch from "./CreateBatch.vue";
import BatchDetail from "./BatchDetail.vue";
import { BacthStatus, creditAdjustTypes } from "@/core/types/CreditAdjustTypes";
import PaymentService from "../../services/PaymentService";

export default /*#__PURE__*/_defineComponent({
  __name: 'BatchIndex',
  setup(__props) {

const isLoading = ref(false);
const createRef = ref<InstanceType<typeof CreateBatch>>();
const detailRef = ref<InstanceType<typeof BatchDetail>>();
const data = ref(<any>[]);

const criteria = ref({
  page: 1,
  size: 20,
  status: "",
  operator: "",
  createdOn: "",
});
const showCreate = () => {
  createRef.value.show();
};

const showDetail = (item: any) => {
  detailRef.value.show(item);
};

const getType = (status: number) => {
  if (status === BacthStatus.completed) {
    return "success";
  } else if (status === BacthStatus.failed) {
    return "danger";
  } else if (status === BacthStatus.processing) {
    return "warning";
  } else if (status === BacthStatus.pending) {
    return "info";
  } else {
    return "";
  }
};
const fetchData = async (_page: number) => {
  isLoading.value = true;
  criteria.value.page = _page;
  try {
    const response = await PaymentService.getBatchList(criteria.value);
    data.value = response.data;
    criteria.value = response.criteria;
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
};

onMounted(() => {
  fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showCreate()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.create")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "success",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (fetchData(1)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.refresh")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_7, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.batchId")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.type")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.status")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.totalAccounts")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.note")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.operatedBy")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.action")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                _createVNode(_component_LoadingRing)
              ]))
            : (!isLoading.value && data.value.length === 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(item.id), 1),
                      _createElementVNode("td", null, _toDisplayString(_unref(creditAdjustTypes)[item.type]), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_tag, {
                          size: "small",
                          type: getType(item.status)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t(`status.${_unref(BacthStatus)[item.status]}`)), 1)
                          ]),
                          _: 2
                        }, 1032, ["type"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.totalAccounts), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_popover, {
                          width: "300",
                          content: item.note,
                          placement: "top"
                        }, {
                          reference: _withCtx(() => [
                            _createElementVNode("div", _hoisted_11, _toDisplayString(item.note), 1)
                          ]),
                          _: 2
                        }, 1032, ["content"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.operatorName), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_TimeShow, {
                          type: "inFields",
                          "date-iso-string": item.createdOn
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: ($event: any) => (showDetail(item))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.detail")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ]))
                  }), 128))
                ]))
        ]),
        _createVNode(_component_TableFooter, {
          onPageChange: fetchData,
          criteria: criteria.value
        }, null, 8, ["criteria"])
      ])
    ]),
    _createVNode(CreateBatch, {
      ref_key: "createRef",
      ref: createRef,
      onFileUploaded: _cache[2] || (_cache[2] = ($event: any) => (fetchData(1)))
    }, null, 512),
    _createVNode(BatchDetail, {
      ref_key: "detailRef",
      ref: detailRef
    }, null, 512)
  ], 64))
}
}

})